
import { Component, Mixins, Prop } from "vue-property-decorator";
import { DebounceMixin, CoachScoutingReportMixin, SportsSelectorMixin } from "@/mixins";
import { DominantSideSelectorMixin } from "@/mixins/selectors/DominantSideSelector";
import { ScoutingReportModel } from '@/models/scoutingReport/ScoutingReportModel';
import { TeamJersey } from "@/models";
import { scoutingReportApi } from "@/api/ScoutingReportApi";
import { wait } from "@/helpers";

@Component
export default class CoachScoutingReport extends Mixins(DebounceMixin, CoachScoutingReportMixin, SportsSelectorMixin, DominantSideSelectorMixin) {
	// from mixin CoachScoutingReportMixin:
	// 	@Prop() reportId: string;
	// 	@Prop() athleteId: string;
	
	@Prop({ type: Boolean}) readonly;

	get FirstName(): string {
		if( !!this.athlete ) return this.athlete.firstName;
		return this.scoutingReport.playerDetails.firstName;
	}
	get LastName(): string {
		if( !!this.athlete ) return this.athlete.lastName;
		return this.scoutingReport.playerDetails.lastName;
	}
	get PlayerType(): string {
		return this.scoutingReport.playerDetails.playerType;
	}
	get DateOfBirth(): Date {
		if( !!this.athlete ) return this.athlete.birthDate;
		return this.scoutingReport.playerDetails.dateOfBirth;
	}

	get TeamName(): string {
		if( !this.team ) return this.scoutingReport.gameDetails.teamName;
		return this.team.name;
	}
	get PlayerNumber(): string {
		if( this.IsNotEmpty(this.player?.number) ) return this.player.number;
		return this.scoutingReport.playerDetails.jerseyNumber.toString();
	}
	get PlayerJersey(): TeamJersey {
		if( !this.team ) return new TeamJersey();
		return this.team.jerseyPrimary;
	}

	async onNewScoutingReport() {
		await this.gotoCoachScoutingReport();
		await this.resetAthleteLink();
		await this.initializeReport();
	}

	async onCancel() {
		if( this.isReportChanged ) {
			if( !confirm(`Are you sure you want to exit this form? Your changes will not be saved.`) ) return;
		}

		this.gotoCoachScoutingReportsSummary();
	}
	
	showNotificationBar: boolean = false;
	notificationColor: string = "success";
	notificationText: string;

	isSaving: boolean = false;
	async onSave(sendReport: boolean = false) {
		this.isSaving = true;
		this.scoutingReport.tags = `${this.scoutingReport.AthleteName}, ${this.TeamName}, ${this.scoutingReport.gameDetails.location}`;
		let savedReport: ScoutingReportModel;
		if( this.IsEmpty(this.scoutingReport.id) ) {
			savedReport = await scoutingReportApi.insertWithOwnership(this.scoutingReport, { params: { supressEvents: false, sendReport }});
			this.scoutingReport.id = savedReport.id;
		} else {
			savedReport = await scoutingReportApi.save(this.scoutingReport, { params: { supressEvents: false, sendReport }});
		}

		if( !sendReport ) await wait(500);
		this.isSaving = false;
		this.isReportChanged = false;
	}

	async onSaveBegin() {
		await this.onSave();

	    window.scrollTo({ top: 0, behavior: 'smooth' });
		this.notificationText = "Scouting Report Saved"
		this.showNotificationBar = true;
	}

	isVisibleSubmitDialog: boolean = false;
	isSubmitting: boolean = false;
	async onSubmit() {
		this.isVisibleSubmitDialog = true;
	}
	async onSubmitProceed() {
		this.isSubmitting = true;
		this.scoutingReport.submitted = true;
		this.isReportChanged = true;
		await this.onSave(true);
		this.isSubmitting = false;
		this.gotoCoachScoutingReportsSummary();
	}
	async onSubmitCancel() {
		this.isVisibleSubmitDialog = false;
	}
}
